/**
 * Motor DIY / payment-retrigger helpers (hash router, confirm-payment-diy).
 * Aligns redirect_url with OtpVerification / dashboard resumeLink patterns.
 */

/** Same default as dashboard retrigger payment action (saveProposal status_id). */
export const DEFAULT_PAYMENT_RETRIGGER_STATUS_ID = 11;

function originBase() {
    return new URL(window.location.href).origin;
}

/**
 * redirect_url value sent with saveProposal (payment retrigger) — no query string.
 * Matches motor proposalSubmission redirect_url pattern.
 */
export function buildProposalDiyReturnLink() {
    return `${originBase()}/#/confirm-payment-diy`;
}

/**
 * Optional transactionId from RM session (dashboard resumeLink).
 * @returns {string|null}
 */
function getRmTransactionId() {
    try {
        const raw = sessionStorage.getItem('rm_data');
        if (!raw) {
            return null;
        }
        const rm = JSON.parse(raw);
        const tid = rm?.transaction_id;
        return tid != null && tid !== '' ? String(tid) : null;
    } catch {
        return null;
    }
}

/**
 * Full shareable Accept & Review Pay URL for the customer (motor DIY page).
 * @param {string|null|undefined} journeyId
 * @returns {string}
 */
export function buildAcceptReviewPayUrl(journeyId) {
    if (journeyId === null || journeyId === undefined || journeyId === '') {
        return '';
    }
    const id = String(journeyId);
    let url = `${originBase()}/#/confirm-payment-diy?journeyId=${encodeURIComponent(id)}`;
    const transactionId = getRmTransactionId();
    if (transactionId) {
        url += `&transactionId=${encodeURIComponent(transactionId)}`;
    }
    return url;
}

/**
 * Alias for parity with health naming where consumers expect "check DIY" URL builder.
 * @param {string|null|undefined} journeyId
 * @returns {string}
 */
export function buildProposalDetailsCheckDiyUrl(journeyId) {
    return buildAcceptReviewPayUrl(journeyId);
}

/**
 * Calls saveProposal with the same payload shape as health dashboard retrigger.
 *
 * @param {Function} backendApi - app mixin backendApi
 * @param {string} journeyId
 * @param {number} statusId
 * @returns {Promise<*>}
 */
export function saveProposalPaymentRetrigger(backendApi, journeyId, statusId) {
    const qData = {
        journey_id: journeyId,
        status_id: statusId,
        redirect_url: buildProposalDiyReturnLink(),
        retrigger: true,
    };
    const headers = {
        Authorization: 'Basic ' + window.btoa(process.env.VUE_APP_USERNPASS),
        'Content-Type': 'application/json',
    };
    return backendApi('saveProposal', qData, headers);
}
